/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import TableGridWithFeatures from '../../../../../SharedModules/Table/TableGridWithFeatures';
import { NDCDetailsTextFieldComponent } from '../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import { getTransitionInvoiceList, getStateData } from '../store/action';
import TransitionDataActionButtons from './TransitionDataActionButtons';
import TRANSITION_INVOICES_TABLE_COLUMNS from './TransitionDataInvoicesTableHeader';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';

const TransitionDataInvoices = ({
  setErrorMessages,
  setSuccessMessages,
  onFullScreenChange,
}) => {
  const [disableRun, setdisableRun] = useState(true);
  const dispatch = useDispatch();
  const defaultUser = useSelector(
    (state) =>
      state.sharedState.UserDefaultReducer.UserDefaultsValues.data.userId
  );
  const { TransitionData } = useSelector((state) => state.sharedState);

  const [stateAbbr, setStateAbbr] = useState('');
  const [stateAbbrList, setStateAbbrList] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);
  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
    onFullScreenChange(!fullScreenView);
  };
  useEffect(() => {
    dispatch(getStateData());
  }, []);
  useEffect(() => {
    dispatch(getTransitionInvoiceList({ stateAbbrev: stateAbbr }));
  }, [stateAbbr]);
  useEffect(() => {
    const listAbbr = TransitionData.stateAbbrevations.map((item) => {
      return { ...item, label: null };
    });
    setStateAbbrList(listAbbr);
  }, [TransitionData.stateAbbrevations]);
  const stateAbbrChangeHanlder = (value) => {
    setStateAbbr(value);
  };

  const buttonClickHandler = async (actionType) => {
    if (!TransitionData?.invoices) {
      setErrorMessages(['Please Select the row in the Gird']);
      return;
    }
    let payLoad = [];
    TransitionData.invoices.forEach((item) => {
      const payloadItem = {
        rpc: item.rebateProgramCd,
        runCd: actionType,
        stateAbbrev: stateAbbr,
        userId: defaultUser,
      };
      payLoad.push(payloadItem);
    });

    const response = await axios.post(
      serviceEndPoint.TRANSITION_DATA_INVOICE_PAYMENT,
      payLoad
    );
    const message = [response.data];
    if (response.status === 200) {
      setSuccessMessages(message);
      setErrorMessages([]);
    } else if (response.status === 400) {
      setErrorMessages(message);
    } else setErrorMessages(message);
  };

  return (
    <>
      <div className='col-md' data-testid='invoice-clientId'>
        {!fullScreenView && (
          <>
            <div className='col-3 mt-2 pl-0'>
              <NDCDetailsTextFieldComponent
                label='State Abbreviation'
                required
                value={stateAbbr}
                className='ml-0 with-select'
                select
                selectReset
                disabled={false}
                selectData={stateAbbrList}
                onChange={(e) => {
                  if (e.target.value === -1) {
                    setdisableRun(true);
                  } else {
                    setdisableRun(false);
                  }
                  stateAbbrChangeHanlder(e.target.value);
                }}
              />
            </div>
            <div className='row'>
              <TransitionDataActionButtons
                onButtonClick={buttonClickHandler}
                disabled={disableRun}
              />
            </div>
          </>
        )}
        <div className='sub-radio no-margin'>
          <TableGridWithFeatures
            rowData={TransitionData.invoices}
            columnDefs={TRANSITION_INVOICES_TABLE_COLUMNS}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenViewClick}
            handleFullScreenView={handleFullScreenViewClick}
            gridHeight={fullScreenView ? '100vh' : 350}
            handleViewHistory={() => {}}
            enterMovesDown
            suppressCellFocus
            helpMessage=''
            data-testid='onEditingStopped'
            fileName='Transition Data'
            onSelect={(e) => {
              setRowData(e.data);
              setdisableRun(false);
            }}
            defaultColDef={{ filter: false }}
            exportFile
          />
        </div>
      </div>
    </>
  );
};

export default TransitionDataInvoices;
